var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 18 18","fill":"currentColor","stroke":"currentColor"}},[_c('path',{attrs:{"d":"M4 9l5 5l4 -5"}}),_c('path',{attrs:{"d":"M9 4l0 12"}}),_c('line',{attrs:{"fill":"none","x1":"15","x2":"3","y1":"16","y2":"16"}})])}
var staticRenderFns = []

export { render, staticRenderFns }